<mat-card class="rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
  <div class="mb-3 flex items-center justify-between gap-3">
    <h3 class="text-lg font-semibold text-slate-900">Dependant</h3>
    @if (!readOnly() && !editing()) {
      <button mat-stroked-button type="button" (click)="edit()">{{ member().dependantId ? 'Change dependant' : 'Capture dependant' }}</button>
    }
  </div>

  @if (editing()) {
    <form [formGroup]="form" (submit)="$event.preventDefault(); save()" class="grid gap-4">
      <p class="text-sm text-slate-500">
        The dependant this case is for. The case goes on whatever the main member answers; the answer is recorded for reporting. A dependant added
        here stays on the employee's file, and the case becomes the dependant's.
      </p>

      @if (existingDependants().length > 0) {
        <mat-radio-group formControlName="mode" class="flex flex-wrap gap-6" aria-label="Which dependant">
          <mat-radio-button value="existing">A dependant on the employee's file</mat-radio-button>
          <mat-radio-button value="new">A new dependant</mat-radio-button>
        </mat-radio-group>
      }

      <div class="grid gap-x-4 md:grid-cols-3">
        @if (form.controls.mode.value === 'existing') {
          <mat-form-field appearance="outline" class="md:col-span-2">
            <mat-label>Dependant</mat-label>
            <mat-select formControlName="dependantId" (selectionChange)="dependantSelected()">
              @for (item of existingDependants(); track item.id) {
                <mat-option [value]="item.id">{{ item.firstName }} {{ item.surname }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (existingStatusText(); as status) {
            <div class="flex flex-col justify-center rounded border border-slate-200 bg-slate-50 px-4 py-3 text-sm">
              <span class="font-medium text-slate-900">Authorisation: {{ status }}</span>
              <span class="text-slate-500">As it is held on the dependant now.</span>
            </div>
          }
        } @else {
          <mat-form-field appearance="outline">
            <mat-label>ID number</mat-label>
            <input matInput maxlength="30" formControlName="idNumber" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput maxlength="100" formControlName="firstName" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Surname</mat-label>
            <input matInput maxlength="100" formControlName="surname" />
          </mat-form-field>
        }

        <mat-form-field appearance="outline">
          <mat-label>Mobile number</mat-label>
          <input matInput maxlength="50" formControlName="contactNumber" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Email address</mat-label>
          <input matInput type="email" maxlength="320" formControlName="emailAddress" />
          @if (form.controls.emailAddress.hasError('email')) {
            <mat-error>Enter a valid email address.</mat-error>
          }
        </mat-form-field>

        @if (form.controls.mode.value === 'new') {
          <lookup-select formControlName="genderId" label="Biological sex" [options]="genders()" />
          <lookup-select formControlName="maritalStatusId" label="Marital status" [options]="maritalStatuses()" />
          <lookup-select formControlName="dependantTypeId" label="Relationship to the member" [options]="dependantTypes()" noneLabel="Other eligible family member" />
        }
      </div>

      <div class="grid gap-2">
        <yes-no-toggle formControlName="authorised" label="Authorised by the main member" (cleared)="clearAuthorisation()" />
        <p class="text-sm text-slate-500">If the member has not answered, a confirmation link is emailed to the employee so they can confirm later.</p>
      </div>

      <sms-code-confirm
        title="Authorise with an SMS code"
        description="A code is sent to the main member's mobile number. The member reads it out and you enter it. A dependant that is not on the employee's file yet is added when the code is sent."
        sendLabel="Send a code to the member"
        verifiedText="The code was right: the dependant is authorised by SMS code."
        [canSend]="canSend()"
        [readOnly]="readOnly()"
        [send]="sendCode"
        [verify]="verifyCode" />

      @if (form.controls.authorised.value === false) {
        <div class="grid gap-4 md:grid-cols-2">
          <lookup-select formControlName="declineReasonId" label="Reason" [options]="declineReasons()" [allowNone]="false" />
          @if (isOtherReason()) {
            <mat-form-field appearance="outline">
              <mat-label>Other (specify)</mat-label>
              <input matInput maxlength="200" formControlName="declineReasonOther" />
            </mat-form-field>
          }
        </div>
      }

      <div class="flex justify-end gap-2">
        <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
        <button mat-flat-button type="submit" [disabled]="store.savingEligibility()">
          @if (store.savingEligibility()) {
            <mat-spinner diameter="20" class="mr-2" />
          }
          Save dependant
        </button>
      </div>
    </form>
  } @else if (member().dependantId) {
    <dl class="grid gap-x-6 gap-y-2 text-sm md:grid-cols-2">
      <div class="flex gap-2">
        <dt class="w-40 shrink-0 text-slate-500">Name</dt>
        <dd class="font-medium text-slate-900">{{ member().dependantName }} {{ member().dependantSurname }}</dd>
      </div>
      <div class="flex gap-2">
        <dt class="w-40 shrink-0 text-slate-500">Relationship</dt>
        <dd class="font-medium text-slate-900">{{ member().dependantType || '-' }}</dd>
      </div>
      <div class="flex gap-2">
        <dt class="w-40 shrink-0 text-slate-500">Contact number</dt>
        <dd class="font-medium text-slate-900">{{ member().dependantMobileNumber || '-' }}</dd>
      </div>
      <div class="flex gap-2">
        <dt class="w-40 shrink-0 text-slate-500">Authorisation</dt>
        <dd class="font-medium text-slate-900">{{ currentStatus() || '-' }}</dd>
      </div>
    </dl>
  } @else {
    <p class="text-sm text-slate-500">The case is for the employee.</p>
  }
</mat-card>
